module.exports = __webpack_public_path__ + "img/Avatar-17.5b03c8bd.svg";